/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Modal, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean;
}

function MyFormControlLabel(props: FormControlLabelProps) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme }) => ({
  variants: [
    {
      props: { checked: true },
      style: {
        ".MuiFormControlLabel-label": {
          color: theme.palette.primary.main,
        },
      },
    },
  ],
}));

export default function ApplyCoupon({ open, onClose, setOpen }: ModalProps) {
  const promoCodes = [
    {
      code: "WELCOME10",
      description:
        "Get 10% off on your first order! This offer is valid for new users only and requires a minimum purchase of $250.",
      showApply: true,
    },
    {
      code: "SAVE20",
      description:
        "Enjoy 20% off when you shop fashion or electronics with Fairu. Valid on orders above $500.",
      showApply: true,
    },
    {
      code: "FREESHIP",
      description:
        "Receive free shipping on all orders over $100. No promo code needed!",
      showApply: true,
    },
    {
      code: "SUMMER15",
      description:
        "Unlock a 15% discount on seasonal items. Offer valid for a limited time only.",
      showApply: true,
    },
  ];

  return (
    <>
      <Modal className="modal billing_summary_modal" open={open} onClose={onClose}>
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="modal_title">
              <h2>Promo Code</h2>
              <button
                type="button"
                className="btn-close"
                onClick={() => setOpen(false)}
              >
                <CloseIcon />
              </button>
            </div>

            <ul className="promocd_lst">
              {promoCodes.map((promo, index) => (
                <li key={index}>
                  <div>
                    <h3>{promo.code}</h3>
                    {promo.showApply && <Button className="btn btn_primary br_15"  onClick={() => setOpen(false)}>Apply</Button>}
                  </div>
                  <p>{promo.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
}